module.exports = __webpack_public_path__ + "static/vascepaStatinMobile-34fd0492bf25bbf088a9b7f84e8a5804.png";